export const CHECKBOX = 'checkbox'
export const EMAIL = 'email'
export const NAME = 'name'
export const NUMBER = 'number'
export const RADIO = 'radio'
export const SELECT = 'select'
export const TEL = 'tel'
export const TEXT = 'text'
export const TEXTAREA = 'textarea'
export const APP_ICON = 'app_icon'
export const APP_SCOPES = 'app_scopes'
export const HIDDEN = 'hidden'
export const URL = 'url'



// WEBPACK FOOTER //
// ./src/containers/Forms/fieldTypes.js